(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .controller('CustomerContentController', CustomerContentController);

    /** @ngInject */
    function CustomerContentController() {
        var vm = this;

        vm.close = function (customer) {
            if (customer) {
                vm.onClose({ customer: customer });
            } else {
                vm.onClose();
            }
        };
    }
})();
